import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("noctua_admin_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/admin/me")
      .then((res) => setAdmin(res.data))
      .catch(() => localStorage.removeItem("noctua_admin_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const res = await api.post("/admin/login", { email, password });
    localStorage.setItem("noctua_admin_token", res.data.token);
    setAdmin({ email: res.data.email });
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem("noctua_admin_token");
    setAdmin(null);
  };

  return (
    <AuthContext.Provider value={{ admin, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be inside AuthProvider");
  return ctx;
};
